<template lang="pug">
div
  .text-md.font-semibold.mb-4 {{ getTitle }}
  .data-table
    v-data-table(:headers="headers" :items="medications" item-key="id" :items-per-page="pageSize" hide-default-footer :loading="isFetching" disable-sort @click:row="onSelected")
      template(v-slot:header.checked)
        yc-checkbox(v-model="checkAll" @change="onCheckedAll")
      template(v-slot:item.number="{ index }")
        .d-flex.fill-height.align-start.mt-9
          .text-xs.neutral500--text.font-bold {{ index+1 }}
      template(v-slot:item.checked="{ item }")
        .d-flex.fill-height.align-start.mt-8
          yc-checkbox(v-model="item.checked" @change="onSelected(item)")
      template(v-slot:item.quantity="{ item }")
        .d-flex.fill-height.align-start.mt-8
          .text-sm.font-normal {{ item.quantity }}
      template(v-slot:item.total="{ item }")
        .d-flex.fill-height.align-start.mt-8
          .text-sm.font-normal {{ item.price | displayPrice }}
      template(v-slot:item.product="{ item }")
        .my-4
          .text-sm.font-semibold.mb-1 {{ item.name }}
          v-row(no-gutters)
            v-col(cols="4")
              .text-xs.font-medium.neutral500--text.mb-1 {{ $t('instruction') }}
            v-col
              .text-xs.font-medium.mb-1 {{ getInstruction(item) }}
          v-row(no-gutters)
            v-col(cols="4")
              .text-xs.font-medium.neutral500--text.mb-1 {{ $t('side_effect') }}
            v-col
              .text-xs.font-medium.mb-1 {{ getPrecaution(item) }}
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    selectedHistory: {
      type: Object,
      required: true
    },
     parentRegistration: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean
    }
  },
  data() {
    return {
      isFetching: false,
      open: true,
      checkAll: false,
      pageSize: -1,
      headers: [
        {
          text: '',
          value: 'checked',
          width: 25
        },
        {
          text: '#',
          value: 'number',
          width: 25
        },
        {
          text: 'item',
          value: 'product',
          width: 350
        },
        {
          text: 'Qty',
          value: 'quantity',
        },
        {
          text: 'Total Price',
          value: 'total',
          width: 150
        }
      ],
      medications: [],
      selectedMedications: []
    }
  },
  mounted () {
    if (this.readonly) {
      this.headers.splice(0, 1)
    }
    this.headers.map(item => item['class'] = 'text-table-header')
    this.medications = this.selectedHistory.medications.map(medication => this.filterMedicationData(medication))
  },
  computed: {
    getTitle() {
      return this.readonly ? this.$t('medication') : this.$t('choose_and_add_to_current_plan')
    },
    isDisabledToSelect() {
      return this.parentRegistration.status !== 'serving'
    },
    isDisabledToViewDetails() {
      return this.selectedMedications.length === 0
    },
  },
  methods: {
    ...mapActions(['showMessage']),
    filterMedicationData(obj) {
      const allowedProperties = ['id', 'name', 'quantity', 'product', 'price', 'extra_data']
      const filteredObj = this.$options.filters.filterAllowedObjectProperties(obj, allowedProperties)
      filteredObj.checked = false
      return filteredObj
    },
    filterPayloadObject(obj) {
      const allowedProperties = ['product', 'quantity', 'price', 'extra_data']
      const filteredObj = this.$options.filters.filterAllowedObjectProperties(obj, allowedProperties)
      filteredObj.product = filteredObj.product.id
      return filteredObj
    },
    getMethod(item) {
      return item.extra_data.method ?? '-'
    },
    hasValue(value) {
      if (typeof value === 'string') {
        value = value.trim()
      }
      return value !== null && value !== undefined && value !== ''
    },
    getInstruction(item) {
      let result = []
      if (this.hasValue(item.extra_data.dosage_value) && this.hasValue(item.extra_data.dosage_unit)) {
        result.push(`${item.extra_data.dosage_value} ${item.extra_data.dosage_unit}`)
      }
      if (this.hasValue(item.extra_data.frequency)) {
        result.push(item.extra_data.frequency)
      }
      if (this.hasValue(item.extra_data.instruction)) {
        result.push(item.extra_data.instruction)
      }
      return result.length > 0 ? result.join(', ') : '-'
    },
    getPrecaution(item) {
      return item.extra_data.precaution ?? '-'
    },
    onCheckedAll() {
      if (this.isDisabledToSelect) {
        this.showMessage(['error', this.$t('error_message.call_patient_in_first')])
        this.$nextTick(() => {
          this.checkAll = false 
        })
        return
      }
      const clone = [...this.medications]
      clone.map(item => item.checked = this.checkAll)
      this.medications = [...clone]
      this.selectedMedications = this.medications.filter(medication => medication.checked === true).map(medication => this.filterPayloadObject(medication))
    },
    onSelected(item) {
      if (this.isDisabledToSelect) {
        this.showMessage(['error', this.$t('error_message.call_patient_in_first')])
        this.$nextTick(() => {
          item.checked = false 
        })
        return
      }
      // item.checked = !item.checked
      this.selectedMedications = this.medications.filter(medication => medication.checked === true).map(medication => this.filterPayloadObject(medication))
      // this.medications = [...this.medications]
      this.checkAll = this.selectedMedications.length === this.medications.length
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .v-data-table__wrapper table tbody tr:hover{
  cursor: pointer;
  background: var(--v-neutral200) !important; 
}
</style>